<template>
    <div :class="['learning-path-paragraph', { 'not-subscribed': !isSubscribed }]">
        <div class="learning-path-paragraph__title">
            {{ title }}
        </div>
        <div class="learning-path-paragraph__content">
            <p>{{ description }}</p>
        </div>
    </div>
</template>

<script>
 export default {
        name: 'SingleLearningPathParagraph',
        props: {
            title: String,
            description: String,
            isSubscribed: Boolean
        }
    }
</script>

<style lang="scss" scoped>
    .learning-path-paragraph {
        margin-bottom: 40px;

        &__title {
            margin-bottom: 20px;
            font-family: Quicksand-Bold, sans-serif;
            border-bottom: solid 10px $manhattan;
            display: inline-block;
            padding-bottom: 5px;
            font-size: 2.4rem;
            [class*="mobile"] & {
                font-size: 1.8rem;
            }
        }

        &__content {
            font-family: Nunito-Regular;
            font-size: 1.8rem;
            font-weight: 400;
            [class*="mobile"] & {
                font-size: 1.4rem;
            }

        }
        &.not-subscribed {
            opacity: 0.5;
        }
    }
</style>
